import { PageLink } from 'assets/layout/core'

export const breadcrumbUpdate: PageLink[] = [
  {
    title: 'Inicio',
    path: '/dashboard',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
